var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.84,
    height: 176.881,
    viewBox: "0 0 120.84 176.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M33.026-35.572l-1.1-18.153a11.116,11.116,0,0,0-10.9-10.595H14.809a13.725,13.725,0,0,0-2.221-.831,15.9,15.9,0,0,0,7.724-13.61,15.91,15.91,0,0,0-15.9-15.895A15.921,15.921,0,0,0-11.494-78.76a15.912,15.912,0,0,0,7.452,13.45,9.369,9.369,0,0,0-2.866.991h-5.476a11.1,11.1,0,0,0-10.9,10.595l-1.1,18.153a10.944,10.944,0,0,0,2.919,8.144,10.1,10.1,0,0,0,7.42,3.239H22.693a10.125,10.125,0,0,0,7.425-3.239A10.935,10.935,0,0,0,33.026-35.572Zm-42.8-41.585a28.7,28.7,0,0,0,5.987-4c2.083-1.96,3.622-5.87,3.622-5.87A13.916,13.916,0,0,0,6.59-80.065c3.3,1.7,8.459,2.706,11.878,3.707A14.3,14.3,0,0,1,4.4-64.464,14.318,14.318,0,0,1-9.773-77.157ZM28.935-28.53A8.529,8.529,0,0,1,22.687-25.8H-14.045a8.518,8.518,0,0,1-6.243-2.733,9.3,9.3,0,0,1-2.477-6.935l1.1-18.153a9.489,9.489,0,0,1,9.29-9.071h3.414a8.278,8.278,0,0,0-1.683,2.775c-1.039,2.781-.181,6.078.282,7.468a5.48,5.48,0,0,0-2.227,2.136c-2.274,3.8-1.449,10.8-.735,14.2a2.1,2.1,0,0,0-.794,1.646,2.119,2.119,0,0,0,2.12,2.12,2.119,2.119,0,0,0,2.12-2.12,2.12,2.12,0,0,0-1.875-2.1c-.639-3.143-1.417-9.62.565-12.917A3.681,3.681,0,0,1-8.83-51.3a2.906,2.906,0,0,1,2.5.645c2.227,1.694,4.032,6.1,4.373,10.5a2.113,2.113,0,0,0-1.507,2.013,2.12,2.12,0,0,0,2.125,2.12,2.119,2.119,0,0,0,2.12-2.12,2.1,2.1,0,0,0-1.1-1.848c-.314-4.986-2.37-9.934-5.028-11.958a4.607,4.607,0,0,0-3.446-1.012c-.4-1.2-1.167-4.1-.309-6.4a6.572,6.572,0,0,1,2.663-3.345h3.585L4.428-52.149,11.7-62.706h2.685a6.974,6.974,0,0,1,4.1,5.215c.559,4.309-1.012,12.752-1.79,16.534a2.507,2.507,0,0,0-.288-.032,3.56,3.56,0,0,0-3.558,3.553,3.565,3.565,0,0,0,3.558,3.558,3.56,3.56,0,0,0,3.553-3.558,3.54,3.54,0,0,0-1.71-3.026c.788-3.782,2.445-12.587,1.838-17.248a7.772,7.772,0,0,0-2.77-5.007h3.713a9.492,9.492,0,0,1,9.284,9.071l1.1,18.153A9.426,9.426,0,0,1,28.935-28.53Z",
    transform: "translate(56.429 139.495)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M90.423-66.873V-32.1c0,40.706-23.368,60.383-41.468,75.58-7.479,6.3-14.041,11.8-17.4,17.636a1.712,1.712,0,0,1-.66.693,1.62,1.62,0,0,1-2.179-.6c-3.393-5.833-9.982-11.335-17.5-17.631C-6.948,28.356-30.417,8.68-30.417-32.1V-66.873a1.61,1.61,0,0,1,1.582-1.614c38.7,0,57.288-33.329,57.549-33.787a1.687,1.687,0,0,1,.6-.591,1.593,1.593,0,0,1,2.168.591c.037.1,18.654,33.787,57.357,33.787A1.613,1.613,0,0,1,90.423-66.873ZM87.222-32.1V-65.323C53.834-66.085,35.116-90.806,30.1-98.449,25.092-90.806,6.337-66.085-27.221-65.323V-32.1c0,39.321,22.809,58.438,40.477,73.241C20.117,46.882,26.21,52.022,30.1,57.493c3.819-5.5,9.955-10.643,16.811-16.449C64.514,26.279,87.222,7.162,87.222-32.1Z",
    transform: "translate(30.417 103.073)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M-7.579-71.264A1.616,1.616,0,0,1-5.965-69.65a1.61,1.61,0,0,1-1.614,1.582h-8.272a1.61,1.61,0,0,1-1.614-1.582,1.616,1.616,0,0,1,1.614-1.614Z",
    transform: "translate(86.455 240.699)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M.627-68.852A1.565,1.565,0,0,1-.955-67.27H-18.688a1.587,1.587,0,0,1-1.587-1.582,1.614,1.614,0,0,1,1.587-1.614H-.955A1.593,1.593,0,0,1,.627-68.852Z",
    transform: "translate(74.298 244.151)",
    fill: "#f2f2f2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkImg4);
export default __webpack_public_path__ + "static/media/work-img4.af092ffc629ffb24cf2be73ab00fca6b.svg";
export { ForwardRef as ReactComponent };